<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE192;</i>
          <span>Manage Chat Idle Time</span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Chat Idle Time</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>

          <form class="example-form" [formGroup]="form">
            <div class="col s12 m2 l2">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="number" mdInput placeholder="Time" maxlength="10" min="1" formControlName="chatIdleTime" [min-max-input]="{formControl:form.controls.chatIdleTime, minValue:0, maxValue: 60}">
                  <p requiredField *ngIf="form.controls.chatIdleTime.invalid && form.controls.chatIdleTime.errors && form.controls.chatIdleTime.errors.required"></p>
                </md-form-field>

              </div>
             
            </div>
            <span class="minute">Minutes</span>
          </form>


          <div class="col s12 m12 l12">
            <div class="button-row">
              <button [disabled]="form.invalid || isUpdateBtnDisable" md-raised-button class="glbAdminBtnCls1" (click)="onUpdateForm()">
                <img src="./assets/images/saveBtnIcon.png" alt="">UPDATE</button>
              <button [disabled]="!isUpdateBtnDisable" md-raised-button class="glbAdminBtnCls1" (click)="onEdit()">
                <img src="./assets/images/editBtnIcon.png" alt="">EDIT</button>
            </div>
          </div>

        </md-card-content>
      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-chat-idle-time/adm-manage-chat-idle-time.component.html